import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';

@Component({
    selector: 'app-pagination',
    standalone: false,
    templateUrl: './pagination.component.html',
    styleUrls: ['./pagination.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class PaginationComponent implements OnChanges {
    @Input() currentPage = 1;
    @Input() totalPages = 0;
    @Input() disabled = false;
    @Input() label = 'Pages';
    @Output() pageChange = new EventEmitter<number>();
    pageInput: number | null = 1;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['currentPage'] || changes['totalPages']) this.resetInput();
    }

    get firstPages(): number[] {
        return Array.from({length: Math.min(3, Math.max(0, this.totalPages))}, (_, index) => index + 1);
    }

    get lastPages(): number[] {
        const start = Math.max(4, this.totalPages - 2);
        return Array.from({length: Math.max(0, this.totalPages - start + 1)}, (_, index) => start + index);
    }

    navigate(page: number): void {
        if (this.disabled || !Number.isInteger(page) || page < 1 || page > this.totalPages) return;
        this.pageInput = page;
        if (page !== this.currentPage) this.pageChange.emit(page);
    }

    jumpToPage(): void {
        const page = this.pageInput;
        if (page !== null && Number.isInteger(page) && page >= 1 && page <= this.totalPages) this.navigate(page);
        else this.resetInput();
    }

    private resetInput(): void {
        this.pageInput = this.totalPages > 0 ? this.currentPage : null;
    }
}
